// packages import
import CloseIcon from '@mui/icons-material/Close';
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { FC } from "react";
// others
import { CustomModalProps } from "../../interfaceTypes";
import { flexCenter } from "../../theme/styleConstants";

export const CustomModal: FC<CustomModalProps> = ({
  isOpen,
  handleClose,
  title,
  children,
  maxWidth,
  width,
  closeOnlyWithButton
}) => (
  <Dialog
    open={isOpen}
    onClose={
      closeOnlyWithButton
        ? (_e, reason) => {
            if (reason === 'backdropClick') return
            handleClose()
          }
        : handleClose
    }
    disableEscapeKeyDown={closeOnlyWithButton}
    maxWidth={maxWidth || 'md'}
    PaperProps={{
      style: {
        margin: 0,
        width: width ?? `calc(100% - 30px)`
      }
    }}
  >
    <Box sx={{ ...flexCenter, justifyContent: 'space-between', borderBottom: '1px solid', borderColor: 'lightGray' }}>
      {/* DialogTitle is `flex: 0 0 auto` by default, so a long title pushed the close button out of the dialog */}
      <DialogTitle fontWeight={400} sx={{ flex: '1 1 auto', minWidth: 0, overflowWrap: 'anywhere' }}>
        {title}
      </DialogTitle>

      <Box paddingRight="10px">
        <IconButton
          edge="start"
          color="inherit"
          onClick={handleClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>

    <DialogContent>{children}</DialogContent>
  </Dialog>
)